import ProjectConvertTypeModalComponent from './project-convert-type-modal.component'

const ProjectConvertTypeModalModule = angular.module('cdbl.project.project-convert-type-modal', [

])
  .component('cdblProjectConvertTypeModal', ProjectConvertTypeModalComponent)
  .name

export default ProjectConvertTypeModalModule
